import { useEffect, useState } from 'react';
import type { PublicPageLink } from '@/features/common/types/PublicPageLink';
import { useLanguage } from '@/i18n/LanguageContext';
import { contentApi } from '@/services/contentApi';

/**
 * The published pages, refetched when the reader switches language so their titles follow.
 *
 * A failure leaves the list empty rather than surfacing an error: the menu and the sitemap still
 * carry every page they name in code, and an extra page missing from a menu is not worth a
 * message on every page of the site.
 */
export function usePublicPageLinks(): PublicPageLink[] {
  const { language } = useLanguage();
  const [pages, setPages] = useState<PublicPageLink[]>([]);

  useEffect(() => {
    let live = true;
    contentApi
      .publicPages()
      .then((list) => {
        if (live) setPages(list);
      })
      .catch(() => {
        if (live) setPages([]);
      });
    return () => {
      live = false;
    };
  }, [language]);

  return pages;
}
